import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

const sharedProps: IconProps = {
  'aria-hidden': true,
  focusable: 'false',
  viewBox: '0 0 24 24',
}

export function PlayIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path fill="currentColor" d="M8 5.25v13.5L19 12 8 5.25Z" />
    </svg>
  )
}

export function DiamondIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <rect
        x="8"
        y="8"
        width="8"
        height="8"
        rx="0.5"
        fill="currentColor"
        transform="rotate(45 12 12)"
      />
    </svg>
  )
}

export function CloseIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props} fill="none">
      <path
        d="m6 6 12 12M18 6 6 18"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function ArrowRightIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props} fill="none">
      <path
        d="M5 12h13m-5-5 5 5-5 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowLeftIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props} fill="none">
      <path
        d="M19 12H6m5 5-5-5 5-5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ExternalLinkIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props} fill="none">
      <path
        d="M14 5h5v5M19 5l-8 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function InstallIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props} fill="none">
      <circle cx="12" cy="13" r="7" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M9 4V2.75M15 4V2.75M12 9v4l2.75 1.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ShieldCheckIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props} fill="none">
      <path
        d="M12 3.5 19 6v5.4c0 4.15-2.72 7.54-7 9.1-4.28-1.56-7-4.95-7-9.1V6l7-2.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="m8.75 12.1 2.15 2.15 4.35-4.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
